import { UserDailyFirstAccessLogType } from '~/api/user_daily_first_access_logs';
import { convertDateTime } from '~/utils/dateTime';
import { LoginReportPresentation } from '../../presentations';

type IConvertToPresentationProps = (args: { data: UserDailyFirstAccessLogType }) => {
  rows: React.ComponentProps<typeof LoginReportPresentation>['rows'];
};

export const convertToPresentationProps: IConvertToPresentationProps = ({ data }) => {
  const rows = data.user_daily_first_access_logs.map((log, index) => ({
    no: index + 1,
    user_name: log.user.full_name,
    email: log.user.email,
    accessed_at: convertDateTime(log.accessed_at),
  }));

  return { rows };
};
